import { Grid } from '@mui/material';
import { Switch } from '@sb/cc-design-system';
import { IOwnerOperatorTagsSectionProps } from 'src/interfaces';
import { lang } from 'src/utils';

import {
  OOToggleLabel,
  OOToggleRow,
  SubHeader,
} from '../../DetailLocationPageOO.styled';

export const OwnerOperatorTagsSectionOO = ({
  isBannerEnabled,
  isMessagingEnabled,
  setIsBannerEnabled,
  setIsMessagingEnabled,
  setIsBannerChanged,
  setIsMessagingChanged,
  isBannerChanged,
  isMessagingChanged,
}: IOwnerOperatorTagsSectionProps) => {
  return (
    <>
      <Grid item xs={12} sx={{ pt: '14px' }}>
        <SubHeader>{lang.ownerOperator.CODMessaging}</SubHeader>
        <OOToggleRow>
          <OOToggleLabel>{lang.banner}</OOToggleLabel>
          <Switch
            checked={isBannerEnabled}
            onChange={() => {
              setIsBannerEnabled(!isBannerEnabled);
              setIsBannerChanged(!isBannerChanged);
            }}
          />
        </OOToggleRow>
        <OOToggleRow>
          <OOToggleLabel>{lang.messaging}</OOToggleLabel>
          <Switch
            checked={isMessagingEnabled}
            onChange={() => {
              setIsMessagingEnabled(!isMessagingEnabled);
              setIsMessagingChanged(!isMessagingChanged);
            }}
          />
        </OOToggleRow>
      </Grid>
    </>
  );
};
